import Vue from 'vue'
import Vuex from 'vuex'

import axios from 'axios';
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        api: "https://registrar.ssi.bclab.dev/",
        registerRequest: {
            executing: false,
            request: undefined,
            response: undefined,
            error: undefined
        },
        example: "",
        client: undefined
    },
    mutations: {
        example(state, value) {
            state.example = value
        },
        builcClient(state) {
            state.client = axios.create({
                baseURL: state.api
            });
        },
        registrationResponse(state, value) {
            state.registerRequest.response = value.response;
            state.registerRequest.error = value.error;
        },
    },
    getters: {
        example: state => {
            return state.example
        },
        registrationPending: state => {
            return state.registerRequest.executing
        },
        registrationSuccess: state => {
            return state.registerRequest.error == undefined &&
                state.registerRequest.response != undefined;
        },
        registrationResponse: state => {
            if (state.registerRequest.response) {
                return state.registerRequest.response
            }
            return state.registerRequest.error
        }
    },
    actions: {
        async registerDid({
            commit,
            state
        }, params) {
            console.log(commit);
            try {
                // reset HTTP call status
                state.registerRequest = {
                    executing: false,
                    request: undefined,
                    response: undefined,
                    error: undefined
                }
                // prepare request data
                const data = {
                    did: params.did,
                    verkey: params.verkey,
                    create: params.create,
                };
                // set status as 'executing'
                state.registerRequest.executing = true
                // make the call
                const response = await state.client({
                    method: "POST",
                    url: "/api/v1/register",
                    data,
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    timeout: 10000, // a timeout of 10 seconds
                });
                commit("registrationResponse", {
                    response: response.data,
                    error: undefined,
                })
            } catch (err) {
                let e = err
                if (err.response) {
                    e = err.response.data;
                }
                commit("registrationResponse", {
                    response: undefined,
                    error: e,
                })
            }
            // call finished. set state back to false
            state.registerRequest.executing = false
        }
    }
})